(function () {
    'use strict';
    var controllerId = '4a_pcProfProfessionaleAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'profProfessionale', 'corsoId', 'opInsert', 'tFigProfessionali', 'settProfess1Id', 'settProfess2Id', fn_4a_pcProfProfessionaleAdd]);

    function fn_4a_pcProfProfessionaleAdd($scope, $uibModalInstance, profProfessionale, corsoId, opInsert, tFigProfessionali, settProfess1Id, settProfess2Id) {
        $scope.tFigProfessionali = [];
        if (settProfess1Id || settProfess2Id) {
            if (settProfess1Id > 0) {
                tFigProfessionali.forEach(function (item) {
                    if (item.GG2SettProfessId == settProfess1Id) {
                        $scope.tFigProfessionali.push(item);
                    }
                });
            }

            if (settProfess2Id > 0) {
                tFigProfessionali.forEach(function (item) {
                    if (item.GG2SettProfessId == settProfess2Id) {
                        $scope.tFigProfessionali.push(item);
                    }
                });
            }
        }
        else {
            $scope.tFigProfessionali = jQuery.extend([], tFigProfessionali);
        }

        if (profProfessionale) {
            $scope.record = jQuery.extend({}, profProfessionale); //Clona oggetto.
            $scope.Title = 'Modifica Profilo (ID: ' + $scope.record.Id + ')';
            
        }
        else {
            $scope.Title = 'Nuovo Profilo';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CNDCorsoId = corsoId;
            $scope.record.OpInsert = opInsert;
            $scope.record.Deleted = false;
            $scope.record.iVersion = 1;
        }


        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            //return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            console.log('openCalendar');
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1) {
                console.log('iOpened == 1');
                $scope.opened1 = true;
            }

        };

        $scope.clear = function ($event, iOpened) {
            console.log('clear');
            if (iOpened == 1) {
                //$scope.record.NascData = '';
                $scope.changed = true;
            }

        };

        $scope.format = "dd/MM/yyyy";



        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return item;
        }

       

    }
})();